<template>
  <div class="container w-full max-w-screen-xl">
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "GettingStarted"
};
</script>
